import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/ky';

const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;

export function usePushSubscription(enabled: boolean) {
  const registered = useRef(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    if (!VAPID_PUBLIC_KEY) return;
    if (
      !('serviceWorker' in navigator) ||
      !('Notification' in window) ||
      !('PushManager' in window)
    )
      return;
    if (registered.current) return;

    registered.current = true;

    (async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const registration = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;

        // Reuse an existing subscription when the browser already has one.
        // Calling subscribe() again with a mismatched applicationServerKey
        // throws a DOMException that was previously swallowed silently.
        let subscription = await registration.pushManager.getSubscription();
        if (!subscription) {
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: VAPID_PUBLIC_KEY,
          });
        }

        const { endpoint, keys } = subscription.toJSON() as {
          endpoint: string;
          keys: { p256dh: string; auth: string };
        };

        await api.post('notifications/me/push-subscription', {
          json: { endpoint, keys, userAgent: navigator.userAgent },
        });

        console.log('[PushSubscription] Registered successfully');
      } catch (err) {
        console.error('[PushSubscription] Registration failed — will retry in 5s:', err);
        registered.current = false;
        setTimeout(() => setAttempt((n) => n + 1), 5000);
      }
    })();
  }, [enabled, attempt]);
}
